import { completeReducer, completeState, createReducer } from 'redux-recompose';
import Immutable from 'seamless-immutable';

import { actions } from './actions';

const stateDescription = {
  description: {
    reviews: []
  }
};

export const initialState = completeState(stateDescription);

const reducerDescription = {
  primaryActions: [actions.GET_REVIEWS, actions.ADD_REVIEW],
  override: {}
};

export default createReducer(
  Immutable(initialState),
  completeReducer(reducerDescription)
);
